var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStarHalf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8019_7755",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2831 7.77559L15.3323 6.91075L12.6722 1.51778C12.5995 1.37013 12.48 1.25059 12.3323 1.17794C11.962 0.995126 11.512 1.14747 11.3268 1.51778L8.66668 6.91075L2.7159 7.77559C2.55184 7.79903 2.40184 7.87637 2.28699 7.99356C2.14815 8.13626 2.07165 8.32825 2.07428 8.52733C2.07692 8.72641 2.15849 8.91631 2.30106 9.05528L6.60653 13.2529L5.58934 19.1803C5.56549 19.3182 5.58074 19.46 5.63338 19.5896C5.68602 19.7193 5.77394 19.8316 5.88716 19.9138C6.00038 19.996 6.13437 20.0449 6.27395 20.0549C6.41352 20.0648 6.5531 20.0355 6.67684 19.9701L11.9995 17.1717L17.3222 19.9701C17.4675 20.0475 17.6362 20.0732 17.7979 20.0451C18.2057 19.9748 18.48 19.5881 18.4097 19.1803L17.3925 13.2529L21.6979 9.05528C21.8151 8.94044 21.8925 8.79044 21.9159 8.62637C21.9792 8.21622 21.6932 7.83653 21.2831 7.77559Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8019_7755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.40039 0H11.9996V24H-2.40039V0Z",
    fill: "url(#paint0_linear_8019_7755)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0H26.4V24H12V0Z",
    fill: "#D6D9DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8019_7755",
    x1: -8.97806,
    y1: 12.3457,
    x2: 11.5883,
    y2: 24.6855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC863"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarHalf);
export default __webpack_public_path__ + "static/media/icon-star-half.f38ecfe976823911c383a2b330621dab.svg";
export { ForwardRef as ReactComponent };